import { Component, Input } from '@angular/core';
import { BadgeSize, BadgeColor, BadgeStyle, BadgeType } from './badge.types';

@Component({
  selector: 'wfm-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  @Input() label: string;

  @Input() icon: string;

  @Input() size: BadgeSize;

  @Input() color: BadgeColor;

  @Input() badgeStyle: BadgeStyle;

  @Input() count: number;

  @Input() type: BadgeType;

  get classes(): string[] {
    const classes: string[] = [];
    if (this.size && this.size !== BadgeSize.medium) classes.push(`badge--${this.size}`);
    if (
      this.color &&
      this.color !== BadgeColor.default &&
      this.badgeStyle !== BadgeStyle.notification &&
      this.type !== BadgeType.notification
    )
      classes.push(`badge--${this.color}`);
    if (this.badgeStyle && this.badgeStyle !== BadgeStyle.square && this.type !== BadgeType.notification)
      classes.push(`badge--${this.badgeStyle}`);
    if (this.type === BadgeType.notification) classes.push('badge--notification');
    return classes;
  }

  get iconSize(): number {
    if (this.size === BadgeSize.small) return 16;
    if (this.size === BadgeSize.large) return 32;
    return 24;
  }
}
